// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__H3h7-","button":"Footer_button__n0uyU"};